import React,{useState} from 'react'
import { NavbarBrand,Nav,Navbar,NavbarToggler,Collapse, NavItem, NavLink, Dropdown, DropdownItem, DropdownToggle, DropdownMenu,} from 'reactstrap';
import {connect} from 'react-redux'



const Navcomponent=(props)=>{
  
  const currenttab=props.currenttab;
  const [dropdownOpen, setDropdownOpen] = useState(false);
const[isOpen,setopen]=useState(false);
  const toggle = () => setDropdownOpen(!dropdownOpen);

 const togglecollapse=()=> {
  
      setopen(!isOpen);
    
  }

  const stylechange={

   
   color:'black',
   backgroundColor:'#211F1D',
   fontSize:'15px',
   
  }

  const stylechange1={

    paddingLeft:'800px'
   }
    return(
      <Navbar  dark expand="md" style={{zIndex:1000}}>
      <NavbarBrand href="/" style={{ fontFamily: 'Trispace,  sans-serif', fontSize:'22px'}}>Mr.Game_dev</NavbarBrand>
      <NavbarToggler onClick={togglecollapse} />
      <Collapse isOpen={isOpen} navbar>
       
      
     <Nav tabs expand="md"  style={isOpen?stylechange:stylechange1}>
      
   
        <NavItem >
          <NavLink  href="/home"  className={currenttab==="Home"?'text-grey':'text-white'}   active={currenttab==="Home"?true:false} >Home</NavLink>
        </NavItem>

        <Dropdown nav isOpen={dropdownOpen} toggle={toggle}  >
          <DropdownToggle nav caret className={dropdownOpen?'text-grey':'text-white'} >
            Games
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem href="/games">Buggy frog</DropdownItem>
           
            
          </DropdownMenu>
        </Dropdown>
      
        <NavItem>
          <NavLink href="/about"  className={currenttab==="About"?'text-grey':'text-white'}  active={currenttab==="About"?true:false}>About</NavLink>
        </NavItem>
        <NavItem>
          <NavLink  href="/joinme"  className={currenttab==="Joinme"?'text-grey':'text-white'}  active={currenttab==="Joinme"?true:false}>join me</NavLink>
        </NavItem>
        <NavItem>
          <NavLink  href="/learn"  className={currenttab==="Learn"?'text-grey':'text-white'}  active={currenttab==="Learn"?true:false}>Learn</NavLink>
        </NavItem>
      </Nav>
      </Collapse>
        </Navbar>
    )
}
const mapstatetoprops=(state)=>{
  return{
    currenttab:state.currenttab.currenttab
  }
}
export default connect(mapstatetoprops)(Navcomponent)